import { Route, Routes } from 'react-router-dom';
import SmartAlbumListScreen from '../screens/Album/SmartAlbumList';
import NotFound from '../screens/Auth/NotFound';
import AlbumPathListScreen from '../screens/Album/AlbumPathList';
import Game from '../screens/Game/Game';
import TryAlbumListScreen from '../screens/Album/TryAlbumList';
import PerformanceReportScreen from '../screens/PerformanceReport/PerformanceReport';

const SpaceRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/:classroomId/try" element={<TryAlbumListScreen />} />
      <Route path="/journey" element={<SmartAlbumListScreen />} />
      <Route
        path="/:classroomId/journey/:gameSetId"
        element={<AlbumPathListScreen />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/game/:gameId"
        element={<Game />}
      />
      <Route
        path="/:clubId/performance-report"
        element={<PerformanceReportScreen />}
      />
      {/* <Route
        path="/:classroomId/journey/:gameSetId/challenge/:index"
        element={<Game />}
      />
      <Route
        path="/:classroomId/journey/:gameSetId/challenge/super"
        element={<Game />}
      /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SpaceRoute;
